// extracted by mini-css-extract-plugin
export default {"subheading":"TermsAndConditions_subheading__f9iI+"};